import {useMemo} from 'react';
import {map} from 'rxjs/operators';
import {useStream} from '@esgi/ui-kit/utils';
import {RenderableFunction} from '@esgi/ui-kit/core';
import {ElementStatus, IFormControl} from './types';

interface Args<T> {
	value: T;
	status: ElementStatus;
}

interface DependElementProps<T> {
	control: IFormControl<T>;
	children?: RenderableFunction<Args<T>>;
}

export function DependElement<T>(props: DependElementProps<T>): JSX.Element {
	const onChange$ = useMemo(() => props.control.onChanged.pipe(map(e => e.currState)), [props.control]);

	const initial = {
		value: props.control.value,
		status: props.control.status,
	};

	const value = useStream<Args<T>>(onChange$) || initial;
	return <>
		{props.children(value)}
	</>;
}
